module.exports = __webpack_public_path__ + "static/media/Xero-Second-Image.3920db07.jpg";